GlobalState.$inject = ['$rootScope', '$state', '$stateParams', 'amMoment'];

function GlobalState($rootScope, $state, $stateParams, ngMoment) {
    'use strict';

    // Set some reference to access them from any scope
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;

    $rootScope.app = {
        name: 'ATC', // name of your project
        version: '0.15.0', // current version
        year: 2018,
        isMobile: (function () { // true if the browser is a mobile device
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true;
            }
            return false;
        })(),
        layout: {
            isSidebarClosed: true, // true if you want to initialize the template with closed sidebar
        },
        online: navigator.onLine
    };

    ngMoment.changeLocale('es');
}

export default GlobalState;